import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['checkbox', 'input'];

  connect() {
    this.checkboxTargets.forEach((checkbox) => {
      let targets = this.inputTargets.filter(
        (input) => input.dataset.targetIndex == checkbox.dataset.targetIndex
      );

      targets.forEach((input) => (input.disabled = checkbox.checked));
    });
  }

  toggle(event) {
    let targets = this.inputTargets.filter(
      (input) => input.dataset.targetIndex == event.target.dataset.targetIndex
    );

    targets.forEach((input) => (input.disabled = event.target.checked));
  }
}
